<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Main Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [class.event-navigation-opened]="isEventNavigationOpened"
    [appearance]="mainNavigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="(navigation$ | async)?.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img
                    class="w-16"
                    src="../../../../../assets/images/home/logo-360-white.png" />
            </div>
            <!-- Components -->
            <div class="flex items-center ml-auto">
                <!--                <notifications></notifications>-->
                <user [showAvatar]="false"></user>
            </div>
        </div>
        <!-- User -->
        <div class="flex flex-col items-center w-full p-4 profile">
            <ng-container *ngIf="user$ | async as user">
                <div class="relative w-24 h-24">
                    <img
                        class="w-full h-full rounded-full"
                        *ngIf="user.avatar"
                        [src]="user.avatar"
                        alt="User avatar">
                    <mat-icon
                        class="icon-size-24"
                        *ngIf="!user.avatar"
                        [svgIcon]="'heroicons_solid:user-circle'"></mat-icon>
                </div>
                <div class="flex flex-col items-center justify-center w-full mt-6"
                     [class.hidden]="isEventNavigationOpened">
                    <div
                        class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                        {{ user.name }}
                    </div>
                    <div
                        class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                        {{ user.email }}
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="filteredOrgList$ | async as orgList">
                <div class="flex justify-center w-full mt-6 underline cursor-pointer org-container"
                     *ngIf="!isEventNavigationOpened">
                    <ng-container *ngIf="selectedOrgInContext as org; else orgEmptyState">
                        <a class="text-center org-link" [routerLink]="['/organizations/dashboard']">
                            <mat-icon class="org-icon" svgIcon="mat_outline:business"></mat-icon>
                            {{ org.name }}
                        </a>
                    </ng-container>
                    <ng-template #orgEmptyState>
                        <a *ngIf="isClubContext && !orgList.length; else orgUnavailableState"
                           class="text-center org-link"
                           [routerLink]="['/organizations/details']">
                            Criar associação
                        </a>
                        <ng-template #orgUnavailableState>
                            <span class="text-center org-link">
                                {{ orgList.length ? 'Sem organização selecionada' : 'Sem organizações disponíveis' }}
                            </span>
                        </ng-template>
                    </ng-template>
                    <mat-icon *ngIf="selectedOrgInContext && orgList.length > 1"
                              svgIcon="mat_solid:keyboard_arrow_down"
                              [matMenuTriggerFor]="orgListTpl"></mat-icon>
                </div>
            </ng-container>
            <mat-menu
                [xPosition]="'before'"
                #orgListTpl="matMenu">
                <span class="org-dropdown-title px-2">
                    <span>Organizações</span>
                </span>
                <mat-divider></mat-divider>
                <ng-container *ngIf="filteredOrgList$ | async as orgList">
                    <button *ngIf="!orgList.length"
                            mat-menu-item
                            disabled>
                        <span>Sem organizações disponíveis</span>
                    </button>
                    <button
                        *ngFor="let item of orgList"
                        mat-menu-item
                        (click)="selectThisOrg(item)"
                        [ngClass]="{'selected-item': selectedOrgInContext?.id === item.id}">
                        <mat-icon *ngIf="selectedOrgInContext?.id === item.id"
                                  class="org-icon"
                                  svgIcon="mat_outline:business"></mat-icon>
                        <span>{{ item.name }}</span>
                    </button>
                </ng-container>
            </mat-menu>
            <ng-container *ngIf="(party$ | async) as party">
                <div class="flex items-center justify-center w-full mt-6 underline cursor-pointer"
                     *ngIf="!isEventNavigationOpened"
                     [routerLink]="['/party/details']">{{ party.name }}
                    <mat-icon svgIcon="mat_solid:call_missed_outgoing"></mat-icon>
                </div>
            </ng-container>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Event Navigation -->
<fuse-vertical-navigation
    *ngIf="eventNavigation && eventNavigation.length > 0"
    class="dark bg-blue-900 print:hidden event-navigation"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'eventNavigation'"
    [navigation]="eventNavigation"
    [opened]="!isScreenSmall"
    (openedChanged)="updateMainNavigationAppearance()">
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex flex-col items-center justify-center w-full p-4 border-b border-blue-700">
            <div class="flex items-center justify-center gap-2 mb-2">
                <mat-icon class="text-yellow-400" [svgIcon]="'heroicons_outline:star'"></mat-icon>
                <span class="text-xs font-semibold text-yellow-400 uppercase tracking-wider">Actividade</span>
            </div>
            <div class="text-sm font-medium text-white text-center truncate w-full px-2" [title]="currentEventName">
                {{ currentEventName }}
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        *ngIf="showLayoutHeader"
        class="layout-header print:hidden dark:shadow-none dark:border-b dark:bg-transparent"
    >
        <!-- Navigation toggle buttons -->
        <div class="flex items-center gap-2">
            <button class="hamburger-menu" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
        </div>

        <!-- Right Section -->
        <div class="flex items-center space-x-4 ml-auto">
            <!-- Event Navigation Toggle Button (Mobile Only) -->
            <button 
                *ngIf="isScreenSmall && eventNavigation && eventNavigation.length > 0"
                class="event-nav-toggle" 
                mat-icon-button 
                (click)="toggleNavigation('eventNavigation')"
                [attr.aria-label]="'Abrir menu de navegação de eventos'">
                <mat-icon [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
            </button>

            <div class="flex items-center" *ngIf="showClubYearSelector">
                <button mat-stroked-button class="org-year-trigger" [matMenuTriggerFor]="organizationYearMenu">
                    <mat-icon class="org-year-icon" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                    <span>Ano {{ selectedOrganizationYear }}</span>
                    <mat-icon class="org-year-chevron" [svgIcon]="'mat_solid:keyboard_arrow_down'"></mat-icon>
                </button>
            </div>
            
            <div class="flex items-center space-x-4" *ngIf="showPartyTrialBanner">

            <!-- Text Information -->
            <span *ngIf="daysToExpire > 1" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Restam {{ daysToExpire }} dias de teste
            </span>
            <span *ngIf="daysToExpire === 1" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                Resta {{ daysToExpire }} dia de teste
            </span>
            <span *ngIf="daysToExpire < 1" class="text-sm font-medium text-gray-700 dark:text-gray-200">
               O período de teste expirou
            </span>
            <button mat-raised-button color="primary" class="btn-primary" [routerLink]="'/payments/bank-transfer'">
                Subscrever
            </button>
            </div>

            <div class="flex items-center space-x-4" *ngIf="showClubUpgradeBanner">
                <span *ngIf="clubPlanIsTrial && clubPlanDaysToExpire > 1" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                    Restam {{ clubPlanDaysToExpire }} dias de teste
                </span>
                <span *ngIf="clubPlanIsTrial && clubPlanDaysToExpire === 1" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                    Resta {{ clubPlanDaysToExpire }} dia de teste
                </span>
                <span *ngIf="clubPlanIsReadOnly && clubPlanIsTrial" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                    O período de teste terminou. A associação está em modo leitura.
                </span>
                <span *ngIf="clubPlanIsReadOnly && !clubPlanIsTrial" class="text-sm font-medium text-gray-700 dark:text-gray-200">
                    O plano expirou. A associação está em modo leitura.
                </span>
                <button mat-raised-button color="primary" class="btn-primary" [routerLink]="'/payments/bank-transfer'">
                    {{ clubUpgradeCtaLabel }}
                </button>
            </div>
        </div>
    </div>

    <mat-menu
        [xPosition]="'before'"
        #organizationYearMenu="matMenu">
        <ng-container *ngFor="let year of availableOrganizationYears">
            <button
                mat-menu-item
                (click)="selectOrganizationYear(year)"
                [ngClass]="{'selected-item': selectedOrganizationYear === year}">
                <mat-icon *ngIf="selectedOrganizationYear === year" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                <span>{{ year }}</span>
            </button>
        </ng-container>
    </mat-menu>


    <!-- Content -->
    <div class="layout-body-content flex flex-col flex-auto" [class.layout-body-content--with-header]="showLayoutHeader">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="mt-6 relative w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden grid grid-cols-1 sm:grid-cols-3">
        <div class="flex flex-wrap sm:flex-nowrap sm:col-span-3 items-center">
            <span class="font-medium text-secondary mr-4">Organiza360 &copy; {{ currentYear }}</span>
            <a
                class="mr-4 sm:ml-auto hover:underline"
                [routerLink]="['/terms-conditions']" [queryParams]="{p: 'inner'}">Termos e Condições
            </a>
            <a
                class="mr-4 hover:underline"
                [routerLink]="['/privacy']" [queryParams]="{p: 'inner'}">Politicas e privacidade
            </a>
            <a
                class="hover:underline"
                [routerLink]="['/cookies']" [queryParams]="{p: 'inner'}">Cookies
            </a>
        </div>
    </div>


</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
